<div class="ticket-summary">
  <div class="back-arrow">
    <a (click)="backToList()">
      <mat-icon>arrow_back</mat-icon>
    </a>
  </div>
  <div class="col">
    <p class="summary-hdr">{{ 'shared.ticketID' | xTranslate | titlecase }}</p>
    <p class="summary-hdr-value">{{ ticketDetail.id }}</p>
  </div>
  <div class="col">
    <p class="summary-hdr">{{ 'shared.createdBy' | xTranslate | titlecase }}</p>
    <p class="summary-hdr-value">{{ ticketDetail.createBy }}</p>
  </div>
  <div class="col">
    <p class="summary-hdr">{{ 'shared.assignedTo' | xTranslate | titlecase }}</p>
    <p
      class="summary-hdr-value"
      [matTooltipClass]="'tooltip'"
      matTooltip="{{ assignedUsers && assignedUsers.join('\n') }}"
    >
      {{ getAssignedToNames() }}
    </p>
  </div>
  <div class="col">
    <p class="summary-hdr">{{ 'shared.updatedBy' | xTranslate | titlecase }}</p>
    <p class="summary-hdr-value">{{ ticketDetail.updateBy }}</p>
  </div>
  <div class="col">
    <p class="summary-hdr">{{ 'shared.daysOpen' | xTranslate | titlecase }}</p>
    <p class="summary-hdr-value">{{ ticketDetail.createTs | momentToNow }}</p>
  </div>
</div>
